import { getUser } from '@jaymathew/ui-shared/apis/Users'
import { User } from 'resources/types'
import { AllowedOverrides } from './queryOptionsUtils.types'
import { getSelectedCompanyId } from 'shared/functions/selectedCompanyAccess'

export type GetUserOptions = {
	userUID: string;
};

export const queryKey = 'user'

const getUserQueryOptions = ({
	userUID,
}: GetUserOptions,
overrides?: AllowedOverrides) => ({
	queryKey: [queryKey, { userUID }],
	queryFn: async (): Promise<User> => {
		const companyID = getSelectedCompanyId() ?? ''
		const result = await getUser<User>(companyID, userUID)
		return result
	},
	// safe overrides
	staleTime: 30 * 1000, // Default stale time is 30 seconds
	...overrides,
})

export default getUserQueryOptions
